import {UAParser} from 'ua-parser-js';

const appVer = `v4.0.5.20`;

export const CONSTANTS = {
    USER_ID: 'user.id',
    USER_ROLE: 'user.role',
    USER_PARTNER: 'user.partner',
    USER_NAME: 'user.name',
    APP_VERSION: 'app.version',
    BROWSER_NAME: 'browser.name',
    BROWSER_VERSION: 'browser.version',
    USER_AGENT: 'browser.ua',
    LOCATION_CITY: 'location.city',
    LOCATION_COUNTRY: 'location.country',
};

function getBrowserInfo() {
    // You can add your custom browser tracking logic here as well.
    // This example uses the ua-parser-js package.
    const parser = new UAParser();
    const result = parser.getResult();
    return {
        browserName: result.browser.name || '',
        browserVersion: result.browser.version || '',
        userAgent: result.ua || '',
    };
}

function getUserId() {
    // You can add your custom user ID tracking logic here as well.
    // This example uses localStorage.
    const storedAccount = localStorage.getItem('account');
    if (storedAccount) {
        const account = JSON.parse(storedAccount);
        let partnerArray = [];
        if (account.role === 'Coordinator') {
            for (const partner of account.partners) {
                partnerArray.push(`${partner.partner_shortname}`);
            }
        }
        if (account.role === 'Representative') {
            partnerArray.push(`${account.partner_shortname}`)
        }
        return {
            userId: account.uid.toString() || 'Not Found',
            userRole: account.role || 'Not Found',
            userPartner: partnerArray.join(', ') || 'Not Found',
            userName: account.fname || 'Not Found',
        };
    } else {
        return {
            userId: 'None',
            userRole: 'None',
            userPartner: 'None',
            userName: 'None',
        };
    }
}

const CustomSpanProcessor = {
    onStart: span => {
        const userData = getUserId();
        const browserInfo = getBrowserInfo();

        span.setAttribute(CONSTANTS.USER_ID, userData.userId);
        span.setAttribute(CONSTANTS.USER_ROLE, userData.userRole);
        span.setAttribute(CONSTANTS.USER_PARTNER, userData.userPartner);
        span.setAttribute(CONSTANTS.USER_NAME, userData.userName);
        span.setAttribute(CONSTANTS.APP_VERSION, appVer);
        span.setAttribute(CONSTANTS.BROWSER_NAME, browserInfo.browserName);
        span.setAttribute(CONSTANTS.BROWSER_VERSION, browserInfo.browserVersion);
        span.setAttribute(CONSTANTS.USER_AGENT, browserInfo.userAgent);
    },
    onEnd: () => Promise.resolve(),
    forceFlush: () => Promise.resolve(),
    shutdown: () => Promise.resolve(),
};

export default CustomSpanProcessor;
